import { render, staticRenderFns } from "./EntityObjectSelector.vue?vue&type=template&id=5caa64de&scoped=true"
import script from "./EntityObjectSelector.vue?vue&type=script&lang=js"
export * from "./EntityObjectSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa64de",
  null
  
)

export default component.exports